import { useQuery } from "@tanstack/react-query";
import type { ID } from "../../data/BaseEntity";
import { getProduct } from "./productsApi";

export const useProductWithId = (productId: ID | undefined) => {
  const { data: product, isLoading } = useQuery({
    queryKey: ["products", productId],
    queryFn: ({ signal }) => getProduct(productId!, signal),
    enabled: productId !== undefined,
  });

  return {
    product,
    isLoading,
  };
};
